module.exports={
    // 登录页
    sjhm: 'Número de móvil',
    qsrdxyzm:'Por favor complete el código de verificación',
    fsyzm:'Enviar código de verificación',
    login:'Iniciar sesión',
    yIDhmmdl:'Inicio de sesión con ID y contraseña',
    qsrID:'Por favor complete el ID',
    qsrmm:'Por favor complete la contraseña',
    ysjhmdl:'Inicio de sesión con número de móvil',
    xzsq:'Por favor seleccione una comunidad',
    zhmmcw:'Error en cuenta o contraseña',
    注册管理员:'Registrar administrador',
    公司名:'Nombre de la empresa',
    //新添加的
    zc:'Registrarse',
    zhmm:'Recuperar contraseña',
    qsrsjhm:'Por favor complete el número de móvil',
    mhzxhq:'Reintentar en segundos',
    hqyzmsb:'¡Error al obtener el código de verificación!',
    sbbczhmqx:'¡El dispositivo no existe o no tiene permiso!',
    ryzc:'Registro de personal',
    sfz:'Documento de identidad',
    hz:'Pasaporte',
    jzz:'Permiso de residencia',
    jsz:'Licencia de conducir',
    nbool:'Masculino',
    ngril:'Femenino',
    qxkmmm:'¡Por favor complete la contraseña de apertura de puerta!',
    qxgh:'¡Por favor complete el número de empleado!',
    scgg:'Carga exitosa',
    scsb:'Carga fallida',
    tpgxsb:'Error al actualizar imagen',
    xlh:'Número de serie',
    wsh:'Sin aprobar',
    ysh:'Aprobado',
    rq:'Fecha',
    cd:'Tarde',
    jb:'Horas extra',
    zat:'Salida temprana',
    qtxbt:'Por favor complete el título',
    qtxnr:'Por favor complete el contenido',
    ysdfkgx:'Hemos recibido sus comentarios. ¡Gracias por sus valiosas sugerencias!',
    fksb:'¡Error al enviar comentarios!',
    lya:'Bluetooth',
    ss:'Buscar',
    lykm:'Apertura por Bluetooth',
    cx:'Consultar',
    yc:'Una vez',
    lc:'Dos veces',
    zx:'En línea',
    lx:'Desconectado',
    kmen:'Abrir puerta',
    // 首页
    yckm:'Apertura remota',
    fkyy:'Cita de visitante',
    fxys:'Compartir llave electrónica',
    ewmkm:'Apertura con código QR',
    smkm:'Escanear para abrir',
    yjkm:'Llave de un toque',
    sy:'Inicio',
    zzzc:'Autoregistro',
    sb:'Dispositivo',
    wd:'Yo',
    cw:'Error',
    // 远程开门页面
    sbmhzwz:'Nombre o ubicación del dispositivo',
    cxwz:'Consultar ubicación',
    sbwz:'Ubicación del dispositivo',
    zt:'Estado',
    km:'Abrir',
    kmcg:'Apertura exitosa',
    kmsb:'Error al abrir puerta',
    // 访客预约页面
    xm:'Nombre',
    rlzp:'Foto facial',
    tj:'Agregar',
    zjlx:'Tipo de documento',
    zjh:'Número de documento',
    xb:'Género',
    sfcs:'Provincia y ciudad',
    sxrs:'Número de acompañantes',
    syo:'Motivos',
    fwyxq:'Período de validez de visita',
    bfrhm:'Número del entrevistado',
    bfrxm:'Nombre del entrevistado',
    tjyy:'Enviar cita',
    // 分享钥匙页面
    sssb:'Buscar dispositivo',
    xzsb:'Seleccionar dispositivo',
    wsb:'Sin dispositivo',
    fwcs:'Visitas',
    bxcs:"veces ilimitadas",
    qjzewmdzjt:'(Por favor apunte este código QR al lente del dispositivo y escanee para abrir la puerta)',
    fxewm:'Generar código QR de compartir',
    fxmm:'Contraseña de compartir',
    // 自主注册页面
    jg:'Lugar de origen',
    hj:'Domicilio registrado',
    qybm:'Departamento de la empresa',
    kh:'Número de tarjeta',
    kmmm:'Contraseña',
    gh:'Número de empleado',
    qd:'Confirmar',
    qtxsjhm:'Por favor complete el número de móvil',
    qtxxm:'Por favor complete el nombre',
    qxzbm:'Por favor seleccione el departamento',
    qszkmmm:'Por favor establezca la contraseña de apertura de puerta',
    qtxgh:'Por favor complete el número de empleado',
    zccg:'Registro exitoso',
    zcsb:'Registro fallido',
    // 我的页面
    txjl:'Registro de acceso',
    fkjl:'Registro de visitantes',
    kqrb:'Informe de asistencia diaria',
    fkwm:'Comentarios',
    tcdl:'Cerrar sesión',
    // 通行记录页面
    txsj:'Tiempo de acceso',
    kmlx:'Tipo de apertura',
    // f访客记录页面
    lfsj:'Tiempo de visita',
    shzt:'Estado de aprobación',
    mygd:'No más',
    // 反馈我们页面
    bt:'Título',
    qsrbt:'Por favor complete el título',
    ly:'Dejar mensaje',
    qsrly:'Por favor complete el mensaje',
    tjfk:'Enviar comentarios',
    zhxx:'Información de cuenta',
    // 退出登录页面
    sfqdtc:'¿Está seguro de cerrar sesión?',
    qx:'Cancelar',

    // 设备搜索页面
	sbss:'Buscar dispositivo',
	kysb:'Dispositivos disponibles',
	ssjg:'Resultados de búsqueda',
	sbtj:'Agregar dispositivo',
	sblx:'Tipo de dispositivo',
	sfwzcj:'¿Es un dispositivo registrado?',
	qxz:'Por favor seleccione',
	azwz:'Ubicación del dispositivo',
	kmzt:'Estado de apertura',
	wifimm:'Contraseña WiFi',
	
	// 设备设置页面
	wlgl:'Configuración de red',
	yggl:'Gestión de empleados',
	qxfp:'Asignación de permisos',
	gxqx:'Actualizar permisos',
	cqsb:'Reiniciar dispositivo',
	cshsb:'Inicializar dispositivo',
	scsb:'Eliminar dispositivo',
	cshPopTips:'Esta operación eliminará todos los permisos de usuario, ¡por favor confirme!',
	qjscz:'¡Por favor tenga cuidado!',
	qrgxqxm:'¿Actualizar permisos?',
	qrcqsbm:'¿Reiniciar dispositivo?',
	dqczjscsb:'¿Eliminar dispositivo?',
	shgl:'Gestión de aprobación',
	bmgl:'Gestión de departamentos',
	rygl:'Gestión de personal',
	ts:'Aviso',
	sbsccg:'Dispositivo eliminado exitosamente',
	sbbcz:'Dispositivo no encontrado',
	sbyc:'¡Dispositivo anormal, por favor verifique si está en línea!',
	mqxhzhmmcw:'¡Error de permiso o contraseña de cuenta!',
	gxqxsb:'Error al actualizar permisos, código de error',
	gxqxcg:'Actualización de permisos exitosa',
	sfyzgq:'Sesión expirada, por favor inicie sesión nuevamente',
	qsryhmm:'¡Por favor complete la contraseña!',
	qcsbcg:'Eliminación exitosa',
	mmcw:'¡Contraseña incorrecta!',
	sbbzxhyc:'Dispositivo no en línea o anormal',
	// 网络管理页面
	czsb:'Buscar dispositivo',
	wifisz:'Configuración WiFi',
	qsrSSID:'Por favor ingrese SSID',
	ytwsz:'Configuración Ethernet',
	DHCPms:'Modo DHCP',
	IPdz:'Dirección IP',
	zwym:'Máscara de subred',
	wg:'Puerta de enlace',
	qsrIP:'Por favor ingrese IP',
	qsrMASK:'Por favor ingrese MASK',
	qsrGATEWAY:'Por favor ingrese GATEWAY',
	sgsz:'Configuración 4G',
	tjxg:'Enviar modificación',
	qxljsb:'Por favor conecte el dispositivo primero',
	qxzms:'Por favor seleccione el modo',
	bnwk:'No puede estar vacío',
	wificsszcg:'Configuración de parámetros WiFi exitosa',
	wifiszsbcwm:'Error en configuración WiFi, código de error',
	mmszsb:'Error en configuración de contraseña',
	szwlmssb:'Error en configuración de modo de red',
	ipdzbnwk:'La dirección IP no puede estar vacía',
	ytwcsszcg:'Configuración de parámetros Ethernet exitosa',
	ytwcsszsb:'Error en configuración Ethernet',
	kqcg:'Activación exitosa',
	gbcg:'Desactivación exitosa',
	kqsb:'Error al activar',
	opentips:'¡Error al abrir! Si falla varias veces, por favor reconecte el dispositivo y vuelva a intentar',
	
	sbtjcgzzszwifics:'Dispositivo agregado exitosamente, configurando parámetros WiFi',
	sbtjcg:'Dispositivo agregado exitosamente',
	zzcxpzwifi:'Reconfigurando WiFi',
	sbycz:'El dispositivo ya existe',
	tjsbsb:'Error al agregar dispositivo',
	// 部门管理
	gm:'Cambiar nombre',
	sc:'Eliminar',
	xgcg:'Modificación exitosa',
	bmbcz:'Departamento no existe',
	myqxhzhcw:'Sin permiso o error de cuenta',
	sbhryygl:'Dispositivo o personal ya asociado, debe limpiar la asociación primero',
	tjcg:'Adición exitosa',
	yczgwj:'El archivo ya existe',
	gjdbnbcz:'Este nodo no puede ser operado',
	bmsc:'Eliminación de departamento',
	xgmc:'Cambiar nombre',
	tjdbmmc:'Nombre del departamento agregado',
	tjzbm:'Agregar subdepartamento',
	// 人员管理页面
	bm:'Departamento',
	wsp:'Sin aprobar',
	rlwzc:'Rostro no registrado',
	rlbfmzc:'Rostro parcialmente registrado',
	rlzcsb:'Error en registro facial',
	xg:'Modificar',
	sccg:'Eliminación exitosa',
	rybcz:'Personal no existe',
	// 人员添加页面
	tjry:'Agregar personal',
	yhxm:'Nombre de usuario',
	qsryhxm:'Por favor ingrese el nombre de usuario',
	zjhm:'Número de documento',
	bmxz:'Selección de departamento',
	yxkssj:'Tiempo de inicio de validez',
	xzrq:'Seleccionar fecha',
	yxjssj:'Tiempo de fin de validez',
	sztx:'Establecer avatar',
	bc:'Guardar',
	qxzxb:'Por favor seleccione el género',
	qsrzjh:'Por favor ingrese el número de documento',
	qsrkh:'Por favor ingrese el número de tarjeta',
	qsrgh:'Por favor ingrese el número de empleado',
	qsrkmmm:'Por favor ingrese la contraseña de apertura de puerta',
	qsryxkssj:'Por favor ingrese el tiempo de inicio de validez',
	qsryxjssj:'Por favor ingrese el tiempo de fin de validez',
	ryycz:'El personal ya existe',
	khycz:'El número de tarjeta ya existe',
	zcsbbcz:'Dispositivo de registro no existe',
	ghycz:'El número de empleado ya existe',
	// 人员修改
	xgryzl:'Modificar datos del personal',
	khbcz:'Número de tarjeta no existe',
	sbcwm:'¡Error! Código de error',
	ryxxhqsb:'Error al obtener información del personal',
	// 权限分配
	sqzt:'Estado de autorización',
	wx:'Inválido',
	yx:'Válido',
	tbzt:'Estado de sincronización',
	wtb:'No sincronizado',
	rlwtb:'Rostro no sincronizado',
	kwtb:'Tarjeta no sincronizada',
	sbmmwtb:'Contraseña de dispositivo no sincronizada',
	tb:'Sincronizar',
	xz:'Seleccionar',
	qxqx:'Seleccionar todo',
	sq:'Autorizar',
	qxzsb:'Por favor seleccione el dispositivo',
	qr:'Confirmar',
	qxzsqsb:'Por favor seleccione el dispositivo a autorizar',
	bftbsb:'Sincronización parcial fallida',
	qcktbzt:'Por favor verifique el estado de sincronización',
	tbsbqcs:'Error de sincronización, por favor apruebe nuevamente y reintente',
	bfscsb:'Eliminación parcial fallida',
	scsbqcs:'Error de eliminación, por favor apruebe nuevamente y reintente',
	tjmk:'Agregar tarjeta',
	rysc:'Eliminación de personal',
	cg:'Exitoso',
	删除成功:'Eliminación exitosa',
    授权成功:'Autorización exitosa',

    //再次新加
	sygx1:'Marcar opcionalmente 1',
	qrmm:'Confirmar contraseña',
	zhmmyx:'Recuperar contraseña por correo electrónico',
	zzhmm:'Recuperar contraseña',
	yxyzm:'Código de verificación por correo electrónico',
	hqyxyzm:'Obtener código de verificación por correo electrónico',
	dt:'Lector',
	mj:'Control de acceso',
	jin:'Entrada',
	chu:'Salida',
	yes:'Sí',
	no:'No',
	ysdyy:'Ya es la primera página',
	syy:'Página anterior',
	xyy:'Página siguiente',
	rmcs:'Ciudades populares',
	xzgjhdq:'Seleccionar país o región',
    zhhyzmcw:'Cuenta o código de verificación incorrecto',
    zhhmmcw:'Cuenta o contraseña incorrecta',
    xyhzc:'Registro de nuevo usuario',
    yhm:'Nombre de usuario',
    qymc:'Nombre de la empresa',
    yx:'Válido',
    qsryx:'Por favor ingrese el correo electrónico',
	yzms:'El código de verificación es',
    qsryxyzm:'Por favor ingrese el código de verificación por correo electrónico',
    yxyzm:'¡Código de verificación por correo electrónico incorrecto!',
    yzmbzq:'Código de verificación incorrecto',
    qsryhm:'Por favor ingrese el nombre de usuario',
    hqyzmcg:'¡Código de verificación obtenido exitosamente!',
    yhycz:'El usuario ya existe',
    mm:'Contraseña',
    xmm:'Nueva contraseña',
    xgmm:'Cambiar contraseña',
    jmm:'Contraseña anterior',
    bf:'Visita',
    qt:'Negociación',
    yycg:'Cita exitosa',
    yysb:'Error en cita',
    bfrbcz:'El entrevistado no existe',
    fkmhsjhmycz:'El nombre del visitante o el número de móvil ya existe',
    mqtczsb:'Error en operación MQTT',
    ljfghy:'Compartir inmediatamente con amigos',
    fzlj:'Copiar enlace',
    bnzydqsj:'No puede ser anterior al tiempo actual',
    yxqbn:'El período de validez no puede exceder 7 días',
    rqxz:'Fecha',
    szcg:'Configuración exitosa',
    szsb:'Error en configuración',
    yhbcz:'El usuario no existe',

    khkm:'Apertura con tarjeta',
    mmkm:'Apertura con contraseña',
    zwkm:'Apertura con huella digital',
    rlkm:'Apertura facial',

    // 手机号国家区
    zgdl:'China continental',
    zgxg:'Hong Kong, China',
    zgam:'Macau, China',
    zgtw:'Taiwán, China',
    afh:"Afganistán",
    ade:'Andorra',
    agt:'Argentina',
    ymny:'Armenia',
    alb:'Aruba',
    adl:"Austria",
    asbj:'Azerbaiyán',

    bhm:'Bahamas',
    bl:'Baréin',
    bbds:'Barbados',
    bjst:'Pakistán',
	bx:'Brasil',
    bels:'Bielorrusia',
    bls:'Bélgica',
	
    cxx:'Corea del Norte',
    cdjny:'Guinea Ecuatorial',
    dg:'Alemania',
    dm:'Dinamarca',
    jbt:'Yibuti',
    dmnjghg:'República Dominicana',
    els:'Rusia',
    egde:'Ecuador',
    aj:'Egipto',
    aseby:'Etiopía',

    fg:'Francia',
    fl:'Finlandia',
    flb:'Filipinas',
    fdg:'Vaticano',

    gby:'Gambia',
    ggghg:'República del Congo',
    glby:'Colombia',
    gb:'Cuba',
    hg:'Corea del Sur',
    hl:'Países Bajos',
    hd:'Haití',

    jbz:'Camboya',
    jlbs:'Kiribati',
    jny:'Guinea',
    jbbw:"Zimbabue",
    kml:'Camerún',
    kmqt:'Islas Caimán',
    kny:'Kenia',
    kwt:'Kuwait',
    kldy:'Croacia',
    lys:'Laos',
    lby:'Libia',
    lwd:'Ruanda',
    mg:'Estados Unidos',
    mlxy:'Malasia',
    mxg:'México',
    nf:'Sudáfrica',
    nbe:'Nepal',
    nrly:'Nigeria',
    nw:'Noruega',
    plqd:'Palaos',
    pty:'Portugal',
    rb:'Japón',
    rd:'Suecia',
    rs:'Suiza',
    stalb:'Arabia Saudita',
    sd:'Sudán',
    slxy:'Santa Lucía',
    tgs:'Tailandia',
    tjs:'Tonga',
    teq:'Turquía',
    wnrl:'Venezuela',
    wl:'Brunéi',
    wkl:'Ucrania',
    xxl:'Nueva Zelanda',
    xjb:'Singapur',
    xby:'España',
    xl:'Grecia',
    xyl:'Hungría',
    ydl:'Italia',
    yg:'Reino Unido',
    ydnxy:'Indonesia',
    yd:'India',
    yn:'Vietnam',
    ylk:'Irak',
    zl:'Chile',
    zfghg:'República Centroafricana',


    wz:'Ubicación',
    lym:'Bluetooth',
    kmcg:'Apertura exitosa',
    kmsb:'Error al abrir puerta',
    qxdkly:'Por favor active el Bluetooth primero',
    手机号码在同一个公司已存在:'El número de móvil ya existe en la misma empresa',
    有效期要大于当前时间:'El período de validez debe ser mayor al tiempo actual',
    请选择部门:'Por favor seleccione el departamento',
    生成成功:  'Generación exitosa',
    长按二维码下载:'Mantenga presionado el código QR para descargar',
    摄像头权限被拒绝:'Permiso de cámara denegado',
    请先打开摄像头:'Por favor active la cámara primero',
    请在浏览器设置中开启摄像头权限:'Por favor active el permiso de cámara en la configuración del navegador y luego reintente escanear',
    知道了:'Entendido',
    加载中:'Cargando',
    应用不支持蓝牙功能:'La aplicación de Telegram no admite la función Bluetooth. Para usar Bluetooth normalmente, se abrirá la función Bluetooth en el navegador google-chrome',
    // 浏览器中打开蓝牙功能:'Abrir función Bluetooth en el navegador',
    复制链接:'Copiar enlace',
    中打开:'Abrir en google-chrome',
    暂无部门:'Sin departamentos',
    链接已复制:'Enlace copiado',
    返回:'Volver atras',
    请将二维码对准摄像头:'Por favor aline el código QR con la cámara',

    免审参数:'Parámetros de exepción',
    自动授权截止时间:'Tiempo de expiración automática',
    请选择日期:'Por favor seleccione la fecha',
    自动授权口令:'Contraseña automática',
    请输入口令:'Por favor ingrese la contraseña',
    自动授权开关:'Cambio automático de contraseña',
    选择日期:'Seleccionar fecha',

}